import type { PhaseRow } from "@/infrastructure/supabase/database.types";

export const UNSCHEDULED_KEY = "unscheduled";

export function findPhaseForDate(date: string | Date, phases: PhaseRow[]): PhaseRow | null {
  const target = typeof date === "string" ? new Date(date) : date;
  if (Number.isNaN(target.getTime())) return null;
  const sorted = [...phases].sort(
    (a, b) => new Date(a.week_of).getTime() - new Date(b.week_of).getTime()
  );
  let match: PhaseRow | null = null;
  for (const p of sorted) {
    if (new Date(p.week_of).getTime() <= target.getTime()) {
      match = p;
    } else {
      break;
    }
  }
  return match;
}

export function groupByPhase<T extends { phase_id: string | null }>(
  items: T[],
  phases: PhaseRow[]
): Map<string, T[]> {
  const groups = new Map<string, T[]>();
  for (const phase of phases) {
    groups.set(phase.id, []);
  }
  groups.set(UNSCHEDULED_KEY, []);
  for (const item of items) {
    const key = item.phase_id && groups.has(item.phase_id) ? item.phase_id : UNSCHEDULED_KEY;
    groups.get(key)!.push(item);
  }
  return groups;
}
